<jha-function-view jhaTitle="Home">
  <div class="row">
    <div class="col-md-4" *ngIf="loggedIn && hasPowerDocPermission">
      <jha-tile
        jhaTitle=" Designer Studio"
        (click)="navigateTo('designerStudio')"
        jhaIconType="AdobePDF"
        jhaSize="Wide"
        jhaLayout="Fixed">
        View/Edit/Add Apps
      </jha-tile>
    </div>
    <div class="col-md-4" *ngIf="loggedIn && hasMyAppStorePermission">
      <jha-tile
        jhaTitle="My PowerFrame Apps"
        (click)="navigateTo('my-powerframe-apps')"
        jhaIconType="ViewIcons"
        jhaSize="Wide"
        jhaLayout="Fixed">
        My PowerFrame Apps
      </jha-tile>
    </div>
    <div class="col-md-4" *ngIf="loggedIn && hasAuditLogsPermission">
      <jha-tile
        jhaTitle="Audit Logs"
        (click)="navigateTo('audit-logs')"
        jhaIconType="Document"
        jhaSize="Wide"
        jhaLayout="Fixed">
        Audit Logs
      </jha-tile>
    </div>
    <div class="col-md-4" *ngIf="loggedIn && hasUserManagementPermission">
      <jha-tile
        jhaTitle="User Management"
        (click)="navigateTo('userManagement')"
        jhaIconType="Person"
        jhaSize="Wide"
        jhaLayout="Fixed">
        View/Edit/Add Users
      </jha-tile>
    </div>
    <div class="col-md-4" *ngIf="loggedIn && hasGuestUserPermission">
      <jha-tile
        jhaTitle="Guest Users"
        (click)="navigateTo('guestUsers')"
        jhaIconType="People"
        jhaSize="Wide"
        jhaLayout="Fixed">
        View/Edit/Add Guest Users
      </jha-tile>
    </div>
    <div class="col-md-4" *ngIf="loggedIn && hasInstManagementPermission">
      <jha-tile
        jhaTitle="Institution"
        (click)="navigateTo('institution')"
        jhaIconType="Bank"
        jhaSize="Wide"
        jhaLayout="Fixed">
        View/Edit/Add Institutions
      </jha-tile>
    </div>
    <div class="col-md-4" *ngIf="loggedIn && hasUserManagementPermission">
      <jha-tile
        jhaTitle="Roles"
        [routerLink]="['/roles']"
        jhaIconType="PeopleGroup"
        jhaSize="Wide"
        jhaLayout="Fixed">
        View/Edit/Add Roles
      </jha-tile>
    </div>
    <!--  <div class="col-md-4" *ngIf="loggedIn && hasServiceConfigPermission">
      <jha-tile
        jhaTitle="Service Configuration"
        (click)="navigateTo('service-configuration')"
        jhaIconType="Tools"
        jhaSize="Wide"
        jhaLayout="Fixed">
        View/Edit/Add Service Configuration
      </jha-tile>
    </div> -->
    <div class="col-md-4" *ngIf="loggedIn && hasManageSymProfilePermission">
      <jha-tile
        jhaTitle="Configure Profile"
        (click)="navigateTo('profile-configuration')"
        jhaIconType="Document"
        jhaSize="Wide"
        jhaLayout="Fixed">
        Configure Profile
      </jha-tile>
    </div>
    <div class="col-md-4" *ngIf="loggedIn && hasManageProjectPermission">
      <jha-tile
        jhaTitle="Manage Project"
        (click)="navigateTo('manage-project')"
        jhaIconType="ViewList"
        jhaSize="Wide"
        jhaLayout="Fixed">
        View/Edit/Add/Deploy Projects
      </jha-tile>
    </div>
    <div class="col-md-4" *ngIf="loggedIn">
      <jha-tile
        jhaTitle="Release Notes"
        (click)="navigateTo('release-notes')"
        jhaIconType="Verify"
        jhaSize="Wide"
        jhaLayout="Fixed">
        View Release Notes
      </jha-tile>
    </div>
  </div>
</jha-function-view>
